export const DRAWER_WIDTH = 240;
export const TABLE_WIDTH = 600;
export const SUBMIT_REVIEW_ENDPOINT = "https://ghd03cd91j.execute-api.ap-southeast-1.amazonaws.com/vphendson/records";
export const USER_ROLE = {
  AppAdmin: "administrator",
  Manager: "manager",
  Supervisor: "supervisor",
  Operator: "operator",
  Customer: "customer"
}